/// <amd-module name="Core/Medius.Core.Web/Scripts/components/emailStatusTab/api/emailMessageApi"/>

import { get } from 'Core/Medius.Core.Web/Scripts/Medius/core/fetch/rest';
import { handleError } from 'Core/Medius.Core.Web/Scripts/lib/errorHandling/errorHandler';
import { EmailMessageDto } from '../models/emailMessageDto';

export type EmailMessageField = 'EmailMessage' | 'EmailContent';

export type EmailMessageFields = 
    | [EmailMessageField]
    | [EmailMessageField, EmailMessageField];

/**
 * Retrieves email message and/or content by email ID
 * @param emailId - The unique identifier of the email
 * @param fields - Optional array of fields to retrieve ('EmailMessage', 'EmailContent')
 * @returns Promise containing the email message and/or content
 */
export async function getEmailMessage(
    emailId: string,
    fields?: EmailMessageFields
): Promise<EmailMessageDto | null> {
    try {
        if (!emailId) {
            handleError(new Error('Email ID is required'));
            return null;
        }

        const query: { fields?: EmailMessageFields } = {};
        if (fields && fields.length > 0) {
            query.fields = fields;
        }

        const result = await get<EmailMessageDto>(`remedium-api/email-message/${emailId}`, query);
        return result || null;
    } catch (e) {
        handleError(e);
        return null;
    }
}